import './hexagonIcon.css';
import { ReactComponent as HexagonShape } from 'assets/techIcons/hexagon.svg';
import { ReactComponent as HexagonShapeSolid } from 'assets/techIcons/hexagon-solid.svg';
import particles from 'assets/gif/particle-loop-transparent.gif';
import { useTheme } from '../ThemeProvider';
import classNames from 'classnames';

const HexagonIcon = ({ imageSrc, text }) => {
  const theme = useTheme();
  const svgOpacity = theme.themeId === 'light' ? 0.7 : 1;

  return (
    <div className={classNames('hexagon-icon')}>
      <HexagonShape
        className={classNames('hexagon-shape')}
        style={{ '--opacity': svgOpacity }}
      />
      <img
        src={imageSrc}
        alt={text}
        className={classNames('hexagon-icon-img')}
      />
      <img
        src={particles}
        alt={''}
        className={classNames('hexagon-icon-particles')}
      />
      <HexagonShapeSolid className={classNames('hexagon-shape-solid')} />
      <div className={classNames('icon-text-wrapper')}>
        <div className={classNames('icon-text')}>{text}</div>
      </div>
    </div>
  );
};

export default HexagonIcon;
